import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';
import { NavLink } from 'react-router-dom';

export default class TrialbalanceReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            accountId: null,
            mode: 2,
            type: this.getDefaultGuid(),
            status: 0,
            phrase: '',
            typeNumber: '',
            typeNumberTo: '',
            subNumber: '',
            subNumberTo: '',
            number: '',
            numberTo: '',
            fromDate: null,
            toDate: null,
            configName: 'trialbalance_report',
			systemModuleId: 8,
            moduleAccessStatus: 1,
            types: [],
            level: 3,
            menuId: 55
		}
    }
    getDocumentTypes() {
        this.httpPost("api/v1/constant/list", {
            filters: {
                type: 4,
            }
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.modes = data.records;
            });
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.getDocumentTypes();
                this.refreshData();
            });
    }
    refreshData(e, outputFormat = "json") {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/report/trial", {
            phrase: this.state.phrase,
            type: this.state.type,
            mode: this.state.mode,
            status: this.state.status,
            typeNumber: this.state.typeNumber,
            typeNumberTo: this.state.typeNumberTo,
            subNumber: this.state.subNumber,
            subNumberTo: this.state.subNumberTo,
            number: this.state.number,
            numberTo: this.state.numberTo,
            level: this.state.level,
            fromDate: this.convertMomentToDb(this.state.fromDate),
            toDate: this.convertMomentToDb(this.state.toDate),
            outputFormat
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (outputFormat == 'excel') this.downloadExcel(data.bs64);
                    if (outputFormat == "json") {
                        this.state.data = data;
                    }
                    this.setState({
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">تراز آزمایشی</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.refreshData(e, "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" placeholder="عنوان حساب" className="form-control" defaultValue={this.state.phrase} onChange={e => this.setState({ phrase: e.target.value })} />
                                            </div>
                                            <div className="form-wrap">
                                                <select className="form-control" defaultValue={this.state.level} onChange={e => this.setState({ level: parseInt(e.target.value) })}>
                                                    <option value="1">سطح گروه</option>
                                                    <option value="2">سطح کل</option>
                                                    <option value="3">سطح معین</option>
                                                    <option value="4">سطح تفصیل</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select className="form-control" defaultValue={this.state.mode} onChange={e => this.setState({ mode: parseInt(e.target.value) })}>
                                                    <option value="2">دو ستونه</option>
                                                    <option value="4">چهار ستونه</option>
                                                    <option value="6">شش ستونه</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.status} onChange={e => this.state.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه اسناد</option>
                                                    <option value="1">قطعی</option>
                                                    <option value="2">موقت</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.type} onChange={e => this.state.type = e.target.value} className='form-control'>
                                                    <option value={this.getDefaultGuid()}>همه انواع</option>
                                                    {this.state.types.map(currency => <option value={currency.id}>{currency.name}</option>)}
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => { this.state.fromDate = e }}
                                                    value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => { this.state.toDate = e }}
                                                    value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-inline flex-nowrap gx-3 mt-2">
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.number} onChange={e => this.state.number = e.target.value} placeholder="از شماره سند" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.numberTo} onChange={e => this.state.numberTo = e.target.value} placeholder="تا شماره سند" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.subNumber} onChange={e => this.state.subNumber = e.target.value} placeholder="از شماره فرعی" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.subNumberTo} onChange={e => this.state.subNumberTo = e.target.value} placeholder="تا شماره فرعی" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.typeNumber} onChange={e => this.state.typeNumber = e.target.value} placeholder="از شماره اختصاصی" type="text" />
                                            </div>
                                            <div className="form-wrap">
                                                <input className="form-control" defaultValue={this.state.typeNumberTo} onChange={e => this.state.typeNumberTo = e.target.value} placeholder="تا شماره اختصاصی" type="text" />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> نمایش</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card-inner p-0">
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text">نام حساب</span></div>
                                        <div className="nk-tb-col text-center"><span className="sub-text">کدحساب</span></div>
                                        <div className="nk-tb-col text-center"><span className="sub-text">کدینگ کامل</span></div>
                                        {this.state.mode === 6 && <div className="nk-tb-col text-center"><span className="sub-text">مانده بدهکار ابتدای دوره</span></div>}
                                        {this.state.mode === 6 && <div className="nk-tb-col text-center"><span className="sub-text">مانده بستانکار ابتدای دوره</span></div>}
                                        {(this.state.mode === 4 || this.state.mode === 6) && <div className="nk-tb-col text-center"><span className="sub-text">گردش بدهکار</span></div>}
                                        {(this.state.mode === 4 || this.state.mode === 6) && <div className="nk-tb-col text-center"><span className="sub-text">گردش بستانکار</span></div>}
                                        <div className="nk-tb-col text-center"><span className="sub-text">مانده بدهکار</span></div>
                                        <div className="nk-tb-col text-center"><span className="sub-text">مانده بستانکار</span></div>
                                    </div>
                                    {this.state.data.records.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text">
                                                    {this.state.level === 1 && <NavLink to={"/report/explore1/" + record.id + "/"}>{record.name}</NavLink>}
                                                    {this.state.level === 2 && <NavLink to={"/report/explore2/" + record.id + "/"}>{record.name}</NavLink>}
                                                    {this.state.level === 3 && <NavLink to={"/report/explore3/" + record.id + "/"}>{record.name}</NavLink>}
                                                    {this.state.level === 4 && <NavLink to={"/report/transactions/" + record.id + "/"}>{record.name}</NavLink>}
                                                </span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.code}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{record.fullCode}</span>
                                            </div>
                                            {this.state.mode === 6 && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.bedInit)}</span>
                                            </div>}
                                            {this.state.mode === 6 && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.besInit)}</span>
                                            </div>}

                                            {(this.state.mode === 6) && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.sumBed)}</span>
                                            </div>}
                                            {(this.state.mode === 6) && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.sumBes)}</span>
                                            </div>}

                                            {(this.state.mode === 4) && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.sumBed + record.bedInit)}</span>
                                            </div>}
                                            {(this.state.mode === 4) && <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.sumBes + record.besInit)}</span>
                                            </div>}

                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.bed)}</span>
                                            </div>
                                            <div className="nk-tb-col">
                                                <span className="sub-text text-center">{this.money(record.bes)}</span>
                                            </div>
                                        </div>
                                    )}<div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text">جمع کل</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        {this.state.mode === 6 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBedInit)}</span>
                                        </div>}
                                        {this.state.mode === 6 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBesInit)}</span>
                                        </div>}

                                        {(this.state.mode === 6) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBedTrans)}</span>
                                        </div>}
                                        {(this.state.mode === 6) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBesTrans)}</span>
                                        </div>}

                                        {(this.state.mode === 4) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBedTrans + this.state.data.sumBedInit)}</span>
                                        </div>}
                                        {(this.state.mode === 4) && <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBesTrans + this.state.data.sumBesInit)}</span>
                                        </div>}

                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBed)}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{this.money(this.state.data.sumBes)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
				<Footer />
			];

		return contents;
	}
}